export class Search {
    page: number = 1;
    rows: number = 10;
    keyword: string = '';
    startDate: string = '';
    endDate: string = '';
}
